import { makeAutoObservable } from "mobx";
import { RArray } from "../../collections";
/**
 * A parent container for all information about the restaurant (menu, timezone, etc...)
 */
export class Restaurant {
    constructor(params) {
        this.id = params.id;
        this.menu = params.menu;
        this.packingAlgorithm = params.packingAlgorithm;
        this.timezone = params.timezone;
        this.appOrigin = params.appOrigin;
        this.orderingPolicy = params.orderingPolicy;
        this.minOrderValue = params.minOrderValue;
        this.crossSellingListProvider = params.crossSellingListProvider;
        this.fulfillmentMethods = params.fulfillmentMethods;
        this._paymentMethods = params.paymentMethods;
        this._paymentChannels = params.paymentChannels;
        this.tips = params.tips;
        makeAutoObservable(this);
    }
    get paymentMethods() {
        if (this.appOrigin === "QrWaiter") {
            return this._paymentMethods.filtered((paymentMethod) => paymentMethod !== "Cash" && paymentMethod !== "Card");
        }
        return this._paymentMethods;
    }
    get paymentChannels() {
        return this.paymentMethods.includes("Online")
            ? this._paymentChannels
            : RArray.empty();
    }
}
